const PERM_KEYS = ["SubscriberPermissions", "Permissions"];

export function getPermissions() {
  for (let key of PERM_KEYS) {
    const raw = sessionStorage.getItem(key);
    if (raw) {
      try {
        return JSON.parse(raw);
      } catch (e) {
        console.error("Invalid JSON in sessionStorage for", key, raw);
      }
    }
  }
  return [];
}

export function getRawConfigs() {
  const permissions = getPermissions();
  const rawConfigs = {};

  permissions.forEach((item) => {
    const menuName = String(item.menu_name || "").toLowerCase();
    if (!rawConfigs[menuName]) rawConfigs[menuName] = [];
    rawConfigs[menuName].push({
      name: item.submenu_name,
      value: item.submenu_name?.toLowerCase().replace(/\s+/g, "-"),
      url: item.url,
      action_pages: item.action_pages,
      actions_pages_url: item.actions_pages_url,
      submenu_sortorder: item.submenu_sortorder,
      add_perm: item.add_perm,
      view_perm: item.view_perm,
      edit_perm: item.edit_perm,
      delete_perm: item.delete_perm,
      download_perm: item.download_perm,
      import_perm: item.import_perm,
    });
  });

  return rawConfigs;
}

export function actionPermissionsService(menu, subMenu) {
  return getRawConfigs()[menu]?.filter((item) => item.name === subMenu) || [];
}

export function actionPermService(actionPermissionsList) {
  return (
    actionPermissionsList?.find((item) => item.action_pages === "") || null
  );
}

export function actionPermFuncService(actionPermissionsList, actionName) {
  return (
    actionPermissionsList?.find((item) => item.action_pages === actionName)
      ?.action_pages || null
  );
}

export function actionPermLinkFuncService(actionPermissionsList, actionName) {
  return (
    actionPermissionsList?.find((item) => item.action_pages === actionName)
      ?.actions_pages_url || null
  );
}
